import { __decorate } from 'tslib';
import { getIconColorSVGFill } from '../../tools/colors.js';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import css_248z from './icons.styles.css.js';

let XIcon = class XIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = '24';
    }
    render() {
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 462.799"
      >
        <path
          fill-rule="nonzero"
          d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"
        />
      </svg>
    `;
    }
};
XIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], XIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], XIcon.prototype, "size", void 0);
XIcon = __decorate([
    customElement('x-icon')
], XIcon);
var XIcon$1 = XIcon;

export { XIcon$1 as default };
//# sourceMappingURL=xIcon.js.map
